import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				borderRadius: 6,
				padding: 10,
				marginBottom: 5,
				marginTop: 10,
				background: theme.palette.grey[600]
			},
			header: {
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				borderBottom: `2px solid ${theme.palette.common.white}`,
				paddingBottom: 5,
				width: "100%"
			},
			title: {
				display: "flex",
				alignItems: "center",
				fontSize: 16,
				fontWeight: 500,
				color: theme.palette.primary.contrastText,
				"& >img": {
					marginRight: 5
				}
			},
			threeDot: {
				overflow: "hidden",
				display: "inline-block",
				textOverflow: "ellipsis",
				whiteSpace: "nowrap"
			},
			btnDefault: {
				color: theme.palette.secondary.main,
				fontSize: 14,
				textAlign: "end",
				cursor: "pointer",
				"&:hover": {
					opacity: 0.7
				},
				"& > img": {
					marginLeft: 3
				}
			},
			quantity: {
				color: theme.palette.primary.contrastText,
				"& > span": {
					color: theme.palette.secondary.main,
					padding: "0px 5px"
				}
			},
			mt10: {
				marginTop: 10
			},
			bodyTextDiscount: {
				display: "flex",
				justifyContent: "space-between",
				color: theme.palette.primary.contrastText,
				fontSize: 14,
				fontWeight: 500,
				marginTop: 10
			}
		}),
	{
		name: "PromotionDetail",
		index: 1
	}
);

export default useStyles;
